import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const GlobalSearch = React.lazy(() => import("@mediaspace/features/global-search"));

export const render = getDsLayoutComponentRenderer(GlobalSearch);
